// extracted by mini-css-extract-plugin
export default {"scoreWrapper":"styles_scoreWrapper__r7tWY","coinScore":"styles_coinScore__yp3Z4","iconWrapper":"styles_iconWrapper__fGwdp"};